import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const doForgotPassword = createAsyncThunk(
  "auth/doForgotPassword",
  async (email, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/forgot-password", { email });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Server error");
    }
  }
);

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState: {
    loading: false,
    status: 'idle',
  },
  reducers: {
    resetStatus: (state) => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(doForgotPassword.pending, (state) => {
      state.loading = true;
    })
    .addCase(doForgotPassword.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(doForgotPassword.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const { resetStatus } = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;
